interface CaseTechnicalActionInput {
  accessioningType?: string | null;
  isConsultation?: boolean | null;
  isGrossingOnly?: boolean | null;
}

export function shouldShowTechnicalPrintActions(
  caseData: CaseTechnicalActionInput | null | undefined
): boolean {
  return (
    caseData?.accessioningType !== "consultation" &&
    caseData?.isConsultation !== true &&
    caseData?.accessioningType !== "grossing_only" &&
    caseData?.isGrossingOnly !== true
  );
}
